import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"

const DeleteAccountCard = () => {
  return (
    <CMSRender
      contentType="AccountSupportCard"
      match={{ "content.name": "DeleteAccountCard" }}
      renderItem={(card) => {
        return (
          <div className="w-full bg-paper rounded-[50px] px-[42px] py-[35px] shadow-card_shadow">
            {/* Title */}
            <Typography 
              variant="h3" 
              className="text-text mb-[27px]"
            >
              {card.title}
            </Typography>

            <Typography
              variant="body1_dim"
              className="w-full mb-[32px]"
            >
              {card.info}
            </Typography>

            <Button variant="error_m">
              {card.cta[0].label}
            </Button>
          </div>
        );
      }}
    />
  )
};

export default DeleteAccountCard;
